import type { MetricOption } from '../../types/geoAnalytics'
// This legend annotates the LIGHT analytics basemap (spec §5.6) — the ramp
// VALUES stay the constant map palette (mapRamps.ts), never viz.seq/viz.div
// tokens. choropleth.ts re-exports these same constants; imported directly
// from mapRamps.ts here per the A6 slice 9 boundary rule.
import { DIVERGING_RAMP, SEQUENTIAL_RAMP, SUPPRESSED_FILL } from './viz/mapRamps'
import { formatLean, suppressionCaption } from './choropleth'
import { ChartLegend } from '../shared/viz'

export function MetricLegend({ option, domain }: { option: MetricOption; domain: [number, number] }) {
  const ramp = option.kind === 'diverging' ? DIVERGING_RAMP : SEQUENTIAL_RAMP
  const [min, max] = domain
  const minLabel = option.format === 'lean' ? formatLean(min) : String(min)
  const maxLabel = option.format === 'lean' ? formatLean(max) : option.format === 'percent' ? `${max}%` : String(max)

  return (
    <ChartLegend
      variant="gradient"
      stops={ramp.map((colorVar) => ({ colorVar }))}
      min={minLabel}
      max={maxLabel}
      mid={option.kind === 'diverging' ? 'EVEN' : undefined}
      suppressed={{ colorVar: SUPPRESSED_FILL, label: suppressionCaption(option.key) }}
    />
  )
}
